/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Allocation_SubmitInputs */

const cs_billing_allocation_submit = /** @type {(inputs: Billing_Allocation_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit alokaci`)
};

const en_billing_allocation_submit = /** @type {(inputs: Billing_Allocation_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save allocation`)
};

/**
* | output |
* | --- |
* | "Save allocation" |
*
* @param {Billing_Allocation_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_allocation_submit = /** @type {((inputs?: Billing_Allocation_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Allocation_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_allocation_submit(inputs)
	return cs_billing_allocation_submit(inputs)
});